<template>
  <Popover
    :popoverClass="['help-tooltip', { transparent: !question }]"
    :placement="placement"
    :trigger="trigger"
    :container="container"
    :popperOptions="{
      modifiers: {
        flip: { enabled: false },
        hide: {
          enabled: false,
        },
        preventOverflow: { enabled: false },
      },
    }"
    :open="isTooltip"
    @show="isTooltip = true"
  >
    <span v-if="question" class="question">?</span>
    <slot v-else name="message">
      <p class="ellipsis">{{ message }}</p>
    </slot>
    <div slot="popover" class="message" :class="{ transparent: !question }">
      <span>{{ message }}</span>
    </div>
  </Popover>
</template>

<script>
/**
 * ヘルプ用ツールチップ
 */
import Popover from '@/components/molecules/Popover'
import { toEllipsis } from '@/utils/string'

export default {
  name: 'HelpTooltip',
  components: {
    Popover,
  },
  props: {
    message: String,
    question: Boolean,
    trigger: {
      type: String,
      default: 'click',
      validator(val) {
        return ['hover', 'focus', 'click'].includes(val)
      },
    },
    placement: { type: String, default: 'bottom' },
    // 親にする要素
    container: { type: String, default: 'body' },
    // window内をscrollした時にtooltipを非表示にする
    scrollHide: { type: Boolean, default: false },
  },
  data() {
    return {
      isTooltip: false,
    }
  },
  mounted() {
    if (this.scrollHide) {
      window.addEventListener('wheel', this.hideTooltip)
      window.addEventListener('touchmove', this.hideTooltip)
    }
  },
  beforeDestroy() {
    if (this.scrollHide) {
      window.removeEventListener('wheel', this.hideTooltip)
      window.removeEventListener('touchmove', this.hideTooltip)
    }
  },
  methods: {
    toEllipsis,
    hideTooltip() {
      if (!this.isTooltip) return
      this.isTooltip = false
    },
  },
}
</script>

<style lang="postcss" scoped>
.question {
  align-items: center;
  background: #9d9d9d;
  border-radius: 50%;
  color: var(--very-light-gray-4);
  display: flex;
  font-size: 13px;
  height: 20px;
  justify-content: center;
  width: 20px;
}

.message {
  font-size: 13px;
  max-width: 328px;
  padding: 13px 16px 18px;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

.v-popover {
  width: 100%;
}
</style>

<style lang="postcss">
.help-tooltip.help-tooltip {
  .popover-inner {
    background-color: var(--very-dark-gray);
    border: 0;
    color: var(--white);
  }

  .popover-arrow.popover-arrow {
    border-color: transparent;
  }

  &[x-placement^='top'] {
    margin-bottom: 24px;

    .popover-arrow::after {
      border-color: var(--very-dark-gray) transparent transparent;
    }
  }

  &[x-placement^='bottom'] {
    margin-top: 24px;

    .popover-arrow::after {
      border-color: transparent transparent var(--very-dark-gray);
    }
  }

  &[x-placement^='right'] {
    margin-left: 24px;

    .popover-arrow::after {
      border-color: transparent var(--very-dark-gray) transparent transparent;
    }
  }

  &[x-placement^='left'] {
    margin-right: 24px;

    .popover-arrow::after {
      border-color: transparent transparent transparent var(--very-dark-gray);
    }
  }

  &.transparent {
    .popover-inner {
      background-color: rgba(51, 51, 51, 0.8);
    }
    &[x-placement^='top'] {
      &.transparent .popover-arrow::after {
        border-color: rgba(51, 51, 51, 0.8) transparent transparent;
      }
    }
    &[x-placement^='bottom'] {
      &.transparent .popover-arrow::after {
        border-color: transparent transparent rgba(51, 51, 51, 0.8);
        top: 0;
      }
    }
    &[x-placement^='right'] {
      &.transparent .popover-arrow::after {
        border-color: transparent rgba(51, 51, 51, 0.8) transparent transparent;
      }
    }
    &[x-placement^='left'] {
      &.transparent .popover-arrow::after {
        border-color: transparen transparent transparent rgba(51, 51, 51, 0.8);
      }
    }
  }
}
</style>
